module.exports = __webpack_public_path__ + "static/media/afiche-coromoto-small.833f1c51.jpg";